<template>
  <div>
    <div class="vx-row">
      <vx-card title="สรุปยอดพันธมิตร">
        <vs-table :key="before_datetime + after_datetime + Math.random()" search :noDataText="noDataText" stripe :data="result">

          <template slot="header">
            <vs-chip color="primary">เริ่มต้น</vs-chip>
            <flat-pickr :config="configDateTimePicker" class="mx-1" v-model="before_datetime"
              placeholder="โปรดเลือกเวลา" />
            <vs-chip color="primary">สิ้นสุด</vs-chip>
            <flat-pickr :config="configDateTimePicker" class="mx-1" v-model="after_datetime"
              placeholder="โปรดเลือกเวลา" />
          </template>

          <template slot="thead">
            <vs-th sort-key="">เว็บไซต์</vs-th>
            <vs-th sort-key="">เปิดยูสใหม่</vs-th>
            <vs-th sort-key="">สมาชิกที่เดิมพัน</vs-th>
            <vs-th sort-key="">แพ้/ชนะ</vs-th>
            <vs-th sort-key="">หลังหักสายบน</vs-th>
            <vs-th sort-key="">ยอดรับโบนัส</vs-th>
            <vs-th sort-key="">หลังหักโบนัส</vs-th>
            <vs-th></vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :key="indextr" v-for="(row, indextr) in data">
              <vs-td><span>{{ row.from_website }}</span></vs-td>
              <vs-td>{{ row.vip }}</vs-td>
              <vs-td>{{ row.count }}</vs-td>
              <vs-td><CurrencyText>{{ row.sum }}</CurrencyText></vs-td>
              <vs-td><CurrencyText>{{ row.after_paid_agent }}</CurrencyText></vs-td>
              <vs-td><CurrencyText>{{ row.bonus_amount }}</CurrencyText></vs-td>
              <vs-td><CurrencyText>{{ row.after_bonus }}</CurrencyText></vs-td>
              <vs-td><vs-button @click="() => selectWebsite(row)">View</vs-button></vs-td>
            </vs-tr>
          </template>

        </vs-table>
      </vx-card>
    </div>
    <div v-if="winlossGamesData.length > 0" class="vx-row my-5">
      <vx-card title="Winloss แยกรายเกม">
        <vs-table :key="before_datetime + after_datetime + Math.random()" search :noDataText="noDataText" stripe :data="winlossGamesData">

          <template slot="header">
            <p v-if="selectedWebsite">{{ selectedWebsite.toUpperCase() }}</p>
          </template>

          <template slot="thead">
            <vs-th sort-key="">เว็บไซต์</vs-th>
            <vs-th sort-key="">เกม</vs-th>
            <vs-th sort-key="">% สายบน</vs-th>
            <vs-th sort-key="">แพ้/ชนะ</vs-th>
            <vs-th sort-key="">หลังหักสายบน</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :key="indextr" v-for="(row, indextr) in data">
              <vs-td>{{ row.from_website }}</vs-td>
              <vs-td>{{ row.sm_type }}</vs-td>
              <vs-td><span>{{ (row.game_agent_pct) * 100 + '%' }}</span></vs-td>
              <vs-td><CurrencyText>{{ row.sum }}</CurrencyText></vs-td>
              <vs-td><CurrencyText>{{ row.after_paid_agent }}</CurrencyText></vs-td>
            </vs-tr>
          </template>

        </vs-table>
      </vx-card>
    </div>
  </div>
</template>

<script>
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import axios from '../../axios'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import vSelect from 'vue-select'
import moment from 'moment'


export default {
  components: {
    flatPickr,
    StatisticsCardLine,
    vSelect
  },
  data () {
    return {
      configDateTimePicker: {
        enableTime: false,
        dateFormat: 'Y-m-d'
      },
      before_datetime: moment.tz('Asia/Bangkok').format('YYYY-MM-DD'),
      after_datetime: moment
        .tz('Asia/Bangkok')
        .add(1, 'days')
        .format('YYYY-MM-DD'),
      lastupdate: moment.tz('Asia/Bangkok').format('YYYY-MM-DD H:mm:ss'),
      index: 0,
      isLoading: false,
      noDataText: 'ไม่พบข้อมูล',
      tableData: [],
      winlossGamesData: [],
      result: []
    }
  },
  async mounted () {
    await this.fetchData()
  },
  methods: {
    selectWebsite (row) {
      this.selectedWebsite = row.from_website
      this.winlossGamesData = this.tableData.winlossGames.filter(item => item.from_website === row.from_website)
    },
    async fetchData () {
      this.isLoading = true
      this.result = []

      const response = await axios
        .get(`ally/winloss/pct/${this.before_datetime}/${this.after_datetime}`)

      this.tableData = response.data.data
      this.result = response.data.data.result

      this.isLoading = false
    }
  },
  computed: {
    currentWebsite () {
      return this.$store.state.currentWebsite
    }
  },
  watch: {
    async currentWebsite (newWebsite, oldWebsite) {
      if (newWebsite.value !== oldWebsite.value) {
        // Put get data function here
        await this.fetchData()
      }
    },
    async before_datetime () {
      await this.fetchData()
    },
    async after_datetime () {
      await this.fetchData()
    }
  }
}

</script>
